import { renderTableTitle } from "@/utils/render.jsx";
import dayjs from "dayjs";
import { getPromotionConfig } from "@/service/promotions";
export default {
  data() {
    const h = this.$createElement;
    return {
      searchList: {
        status: [{
          value: "F",
          title: $t("eymx2", "启用")
        }, {
          value: "T",
          title: $t("eb7w2", "停用")
        }]
      },
      config: {
        ref: "proTable",
        toolBarActions: ["new", "refresh", "fullscreen", "rowSetting"],
        request: "/api/promotion/page",
        submitForm: "/api/promotion/save",
        search: {
          value: {
            startDate: "",
            endDate: "",
            promotionSpaceCode: "NOTICE"
          }
        },
        form1: {
          value: {
            startDate: "",
            endDate: ""
          }
        },
        columns: [{
          key: "id",
          title: "id",
          isAdd: true,
          notShowSearch: true,
          notShowForm: true,
          notShowTable: true
        }, {
          title: $t("ij5d2", "标题"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "name",
          renderSearch: {
            type: "Input",
            props: {}
          },
          formLineNum: "3"
        }, {
          title: $t("edas2", "内容"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "content",
          notShowSearch: true,
          renderForm: {
            type: "Input",
            props: {
              type: "textarea",
              rows: 10,
              "show-word-limit": true,
              maxlength: 521
            }
          },
          formLineNum: "3"
        }, {
          title: $t("ff9l2", "图片"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "pictureUrl",
          notShowSearch: true,
          renderForm: {
            type: "Input",
            props: {}
          },
          renderSearch: {
            props: {}
          },
          formLineNum: "3"
        }, {
          title: $t("ihywtl4", "跳转地址"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "redirectUrl",
          notShowSearch: true,
          formLineNum: "3"
        }, {
          title: $t("bzkvr3", "优先级"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "priority",
          notShowSearch: true,
          renderForm: {
            type: "Rate",
            props: {
              count: 3,
              showText: true
            }
          },
          renderTable: {
            type: "Rate",
            props: {
              count: 3,
              disabled: true
            }
          },
          formLineNum: "1"
        }, {
          title: $t("i7zt2q4", "起始时间"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "startDate",
          notShowSearch: false,
          renderSearch: ({
            value,
            input
          }) => {
            return h("DatePicker", {
              "attrs": {
                "value": value,
                "type": "daterange",
                "placeholder": $t("il014u4", "选择时间"),
                "clearable": false
              },
              "on": {
                "input": pre => {
                  if (pre && pre.length > 0 && pre[0]) {
                    this.config.search.value.startDate = `${dayjs(pre[0]).format("YYYY-MM-DD")}`;
                    this.config.search.value.endDate = `${dayjs(pre[1]).format("YYYY-MM-DD")}`;
                    input(pre);
                  }
                }
              }
            });
          },
          validate: [],
          renderForm: {
            type: "DatePicker",
            props: {
              type: "daterange",
              placeholder: $t("il014u4", "选择时间")
            },
            format: {
              formatWapper: true,
              value: "{startDate:this.$dayjs(value[0]).format('YYYY-MM-DD'),endDate:this.$dayjs(value[1]).format('YYYY-MM-DD')}"
            }
          },
          formLineNum: "2"
        }, {
          title: $t("ctyiie4", "截止时间"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "endDate",
          renderSearch: {
            type: "DatePicker",
            props: {
              type: "datetimerange"
            }
          },
          notShowSearch: true,
          renderForm: {
            type: "DatePicker",
            props: {
              format: "yyyy-MM-dd"
            }
          },
          formLineNum: "3",
          notShowForm: true
        }, {
          title: $t("d8p6qr4", "是否停用"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "isHalt",
          formLineNum: "1",
          renderForm: ({
            value,
            input
          }) => {
            return h("div", {
              "style": {
                width: "50px"
              }
            }, [h("i-switch", {
              "attrs": {
                "size": "large",
                "value": value,
                "true-value": "F",
                "false-value": "T"
              },
              "on": {
                "input": input
              }
            }, [h("span", {
              "slot": "open"
            }, [$t("eymx2", "启用")]), h("span", {
              "slot": "close"
            }, [$t("eb7w2", "停用")])])]);
          },
          renderTable: (h, {
            row
          }) => {
            return h("i-switch", {
              "attrs": {
                "size": "large",
                "true-value": "F",
                "false-value": "T"
              },
              "on": {
                "on-change": val => this.changeConfig(val, row)
              },
              "model": {
                value: row.isHalt,
                callback: $$v => {
                  this.$set(row, "isHalt", $$v);
                }
              }
            }, [h("span", {
              "slot": "open"
            }, [$t("eymx2", "启用")]), h("span", {
              "slot": "close"
            }, [$t("eb7w2", "停用")])]);
          },
          renderSearch: ({
            value,
            input
          }) => {
            return h("pro-select", {
              "attrs": {
                "value": value,
                "list": this.searchList.status
              },
              "on": {
                "input": input
              }
            });
          }
        }, {
          title: $t("d1q70n4", "操作单位"),
          key: "operateUnit",
          notShowSearch: true,
          notShowTable: true,
          notShowForm: true
        }, {
          title: $t("hge52", "排序"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "listOrder",
          notShowSearch: true,
          renderForm: {
            type: "Input",
            props: {
              type: "number"
            }
          },
          formLineNum: "2",
          validate: [{
            code: "number",
            title: $t("b3norf4", "匹配数字"),
            pattern: {},
            message: $t("2j8e0g5", "请输入数字"),
            trigger: "blur,change",
            type: null
          }],
          formWidth: 30
        }, {
          title: $t("chspy3", "创建者"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "createUser",
          notShowSearch: true,
          notShowForm: true
        }, {
          title: $t("ar84e54", "创建时间"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "createDatetime",
          notShowSearch: true,
          notShowForm: true
        }, {
          title: $t("c747j3", "修改人"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "modifyUser",
          notShowSearch: true,
          notShowForm: true
        }, {
          title: $t("ai9edl4", "修改时间"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "modifyDatetime",
          notShowSearch: true,
          notShowForm: true
        }, {
          title: $t("kwg6vf6", "资源位置代码"),
          key: "promotionSpaceCode",
          notShowSearch: true,
          notShowTable: true,
          notShowForm: true
        }, {
          title: $t("ia0s5p4", "资源位置"),
          key: "promotionSpaceName",
          notShowSearch: true,
          notShowTable: true,
          notShowForm: true
        }, {
          title: $t("jbpwm55", "单位 id"),
          key: "unitId",
          notShowSearch: true,
          notShowTable: true,
          notShowForm: true,
          renderTable: {
            props: {}
          }
        }, {
          title: $t("hkxb2", "操作"),
          renderHeader: (h, {
            column
          }) => {
            // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
            return renderTableTitle(column.title, column, h);
          },
          key: "action",
          isAdd: true,
          notShowSearch: true,
          notShowForm: true,
          notShowTable: false,
          actions: [{
            type: "edit",
            title: $t("mekb2", "编辑"),
            request: "/api/promotion/update",
            method: "POST",
            keys: ["id", "name", "priority", "pictureUrl", "redirectUrl", "startDate", "endDate", "content", "listOrder", "isHalt"],
            _checked: true
          }, {
            type: "delete",
            title: $t("eslg2", "删除"),
            request: "/api/promotion/delete",
            method: "POST",
            keys: ["id"]
          }]
        }],
        map: {
          dataPath: "data.retVal.datas",
          totalPath: "data.retVal.totalRows",
          message: "msg"
        },
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        form: {
          modalWidth: 1000,
          value: {
            promotionSpaceCode: "NOTICE",
            startDate: "",
            endDate: "",
            isHalt: "F",
            priority: "1",
            listOrder: "1"
          }
        }
      }
    };
  },
  methods: {
    onSearch() {
      this.$refs[this.config.ref].searchAction();
    },
    onClickTab(value) {
      console.log(value);
      this.config.search.value.promotionSpaceCode = value;
      this.config.form.value.promotionSpaceCode = value;
      this.onSearch();
    },
    async changeConfig(value, row) {
      const params = {
        id: row.id,
        name: row.name,
        content: row.content,
        isHalt: value
      };
      const res = await getPromotionConfig(params);
      if (res.data && res.data.result == 0) {
        this.$Message.success(value === "F" ? $t("cc5y4e4", "开启成功") : $t("aw9ka14", "关闭成功"));
        this.isHalt = value;
      } else {
        this.isHalt = value === "T" ? "F" : "T";
      }
    }
  }
};